import { render, staticRenderFns } from "./BloggerRankingChannelAdult.vue?vue&type=template&id=52054e94&"
import script from "./BloggerRankingChannelAdult.vue?vue&type=script&lang=js&"
export * from "./BloggerRankingChannelAdult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports